import { ValidationRule } from '@ant-design/compatible/lib/form/Form';

import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import { LINK_ID_REQUIRED_TYPES, LINK_URL_REQUIRED_TYPES } from '../constants';
import { CategoryBannerSlideFormItem, InnerRules, SlidePeriod } from '../types';

const START_DATE_REQUIRED_MSG = '시작일은 필수입니다.';
const START_DATE_BEFORE_END_DATE_MSG = '시작일은 종료일 이전까지만 입력 가능합니다.';

/**
 * 슬라이드 내부 필드 검증 규칙. linkType에 따라 link / linkUrl의 필수 여부가 달라지므로
 * 슬라이드 단위로 계산한다. isNonLink=true면 validation은 모두 스킵하지만,
 * hideIf는 오직 linkType 전환에만 반응하도록 분리한다(필드 unmount로 값이 증발하는 것 방지).
 */
export const getInnerRules = (item: CategoryBannerSlideFormItem): InnerRules => {
  const linkTypeNeedsLinkId = LINK_ID_REQUIRED_TYPES.includes(item.linkType);
  const linkTypeNeedsLinkUrl = LINK_URL_REQUIRED_TYPES.includes(item.linkType);
  const needLinkId = !item.isNonLink && linkTypeNeedsLinkId;
  const needLinkUrl = !item.isNonLink && linkTypeNeedsLinkUrl;

  return {
    mobileImage: {
      rules: [{ required: true, message: REQUIRED_MSG }],
    },
    pcImage: {
      rules: [{ required: true, message: REQUIRED_MSG }],
    },
    exposurePeriod: {
      // value가 SlidePeriod 객체이므로 `required: true`(default type='string')와 함께 쓰면
      // async-validator의 type check가 먼저 실패하여 rule.message로 폴백된다.
      // validator 단독으로 모든 케이스(누락/역전)를 처리하고, 별표는 Form.Item required prop이 담당한다.
      rules: [
        {
          validator: (_, value: SlidePeriod, callback: (message?: string) => void) => {
            if (!value?.startDate) {
              callback(START_DATE_REQUIRED_MSG);
              return;
            }
            // 'YYYY-MM-DD HH:mm:ss' 포맷은 사전식 비교와 시간순 비교가 일치하므로 문자열 비교로 충분
            if (value.endDate && value.startDate >= value.endDate) {
              callback(START_DATE_BEFORE_END_DATE_MSG);
              return;
            }
            callback();
          },
        },
      ],
    },
    link: {
      hideIf: !linkTypeNeedsLinkId,
      rules: [{ required: needLinkId, message: REQUIRED_MSG }],
    },
    linkUrl: {
      hideIf: !linkTypeNeedsLinkUrl,
      rules: [{ required: needLinkUrl, message: REQUIRED_MSG }],
    },
  };
};

/**
 * 슬라이드 배열 자체 검증 규칙 (정적).
 * 빈 배열 저장은 허용하며, 빈 상태로 저장 시 호출 측에서 DELETE로 라우팅한다.
 */
export const bannerFormRules = {
  slides: {
    rules: [] as ValidationRule[],
  },
};
